// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { reportLetterArrival } from "./letter_arrival"
import { startTracking } from "./track"

reportLetterArrival()
startTracking()

// The offline page and notifications (app/views/pwa/service-worker.js;
// controllers/push_controller.js registers it too, when turning them on). Registered after load so
// it never competes with the first paint; failure is silent, since a browser
// without service workers loses nothing but a nicer error page.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker", { scope: "/" }).catch(() => {})
  })
}
